"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_row_style_1 = require("./table-row-style");
function TableRow(props) {
    var innerRef = props.innerRef;
    return (0, jsx_runtime_1.jsx)(table_row_style_1.StyledTableRow, __assign({}, props, { ref: innerRef }));
}
exports.TableRow = TableRow;
